import * as actions from './actions'

// initial state
const state = {
  prepaidCardChargeUsedHistory: {
    all_count: 0,
    inquiry_response_count: 0,
    card_usage_info_listV2: []
  }
}

// getters
const getters = {
  prepaidCardChargeUsedHistory: (state) => {
    return state.prepaidCardChargeUsedHistory
  }
}

// mutations
const mutations = {
  SET_PREPAID_CARD_CHARGE_USED_HISTORY (state, data) {
    state.prepaidCardChargeUsedHistory = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
